export const BRAND = {
  name: "it's Malie",
  tagline: "Faith. Freedom. Legacy.",
  hero_headline_lines: ["SOUND THAT", "MOVES CULTURE."],
  overline: "MUSIC. PURPOSE. LEGACY.",
  short_bio:
    "Timeless music rooted in purpose. Creating art that inspires, uplifts, and leaves a legacy.",
  logo: "https://customer-assets.emergentagent.com/job_b4dce826-7c49-4fdc-8fca-fbfef9dae5ff/artifacts/ouz4ijbv_its%20malie%20logo.jpg",
  portrait:
    "https://customer-assets.emergentagent.com/job_b4dce826-7c49-4fdc-8fca-fbfef9dae5ff/artifacts/t67rja55_ChatGPT%20Image%20May%2016%2C%202026%2C%2007_04_21%20PM.png",
  email: "blackvesselrecords@gmail.com",
  management: "Management — Black Vessel Records",
  press: "blackvesselrecords@gmail.com",
  pressRelease:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_malie-cinema/artifacts/3f8bmtef_Malie_Complete_PR_Media_Package.pdf",
};

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Music", href: "#music" },
  { label: "Videos", href: "#videos" },
  { label: "About", href: "#about" },
  { label: "Merch", href: "#merch" },
  { label: "Booking", href: "#booking" },
  { label: "Contact", href: "#contact" },
];

export const STREAMING = {
  spotify:
    "https://open.spotify.com/artist/0TgByvp14mLiNciwnc5V5A?si=J3CBbNPgSeGGrsgJX4n3vA",
  appleMusic:
    "https://music.apple.com/us/artist/ali-spas-its-malie/1893976943",
  tidal: "https://tidal.com/artist/78058619/u",
  youtubeMusic:
    "https://music.youtube.com/channel/UC7xZEav48bs4-SAoRejFT4A?si=bM7qZiFGou5uXIUy",
  soundcloud: "https://soundcloud.com/search?q=its%20malie",
  etsy: "https://minhizeeshop.etsy.com",
};

// Featured video — single video.
export const VIDEOS = [
  {
    id: "lMNWziUCv34",
    title: "Head in the Sky",
    subtitle: "Feat. Shez Treble — Official Video",
    thumb: `https://img.youtube.com/vi/lMNWziUCv34/maxresdefault.jpg`,
  },
];

// Real audio provided by artist.
export const TRACKS = [
  {
    id: "t1",
    title: "Head in the Sky",
    feat: "feat. Shez Treble",
    duration: "3:42",
    art: "https://customer-assets-rejwkqb3.emergentagent.net/job_malie-cinema/artifacts/bxhc89cf_Its_Malie_Banner_Now_Playing.png",
    src: "https://customer-assets-rejwkqb3.emergentagent.net/job_malie-cinema/artifacts/mt39jlu8_Malie_Head%20in%20the%20Sky%20Mixdown.mp3",
  },
];

export const STATS = [
  { label: "Streams", value: "12M+" },
  { label: "Followers", value: "240K" },
  { label: "Shows", value: "180+" },
  { label: "Awards", value: "07" },
];

export const TIMELINE = [
  { year: "2018", title: "Debut single released", body: "First track hits indie playlists." },
  { year: "2020", title: "International tour", body: "Performed across 12 cities in 3 countries." },
  { year: "2022", title: "Faith. Freedom. Legacy. EP", body: "Critical-favorite breakthrough record." },
  { year: "2024", title: "Head in the Sky", body: "Featured in editorial playlists worldwide." },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1565035010268-a3816f98589a?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1522158637959-30385a09e0da?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=1200&q=80",
  "https://images.unsplash.com/photo-1516280440614-37939bbacd81?auto=format&fit=crop&w=1200&q=80",
];

export const MERCH = [
  {
    name: "Community of United Focus Hoodie",
    price: "$54",
    img: "https://customer-assets.emergentagent.com/job_malie-cinema/artifacts/fzpii2uk_unisex-heavy-blend-hoodie-black-front-69b8962a19473.png",
    type: "Hoodie",
    fit: "contain",
    bg: "#000000",
  },
  {
    name: "G.R.O.U.P Hooded Long Sleeve",
    price: "$48",
    img: "https://customer-assets.emergentagent.com/job_malie-cinema/artifacts/wpyemwak_unisex-hooded-long-sleeve-tee-white-front-69b896ae6497c.png",
    type: "Hooded Tee",
    fit: "contain",
    bg: "#0a0a0a",
  },
  {
    name: "Minhizee Structured Cap",
    price: "$28",
    img: "https://customer-assets.emergentagent.com/job_malie-cinema/artifacts/2oj5nq4q_closed-back-structured-cap-black-front-69b898733314d.png",
    type: "Cap",
    fit: "contain",
    bg: "#000000",
  },
  {
    name: "CUF White Hoodie — Lifestyle",
    price: "$54",
    img: "https://customer-assets.emergentagent.com/job_malie-cinema/artifacts/bjzoizdd_CUF%20Hoodie%20White.jpg",
    type: "Hoodie",
    fit: "cover",
    bg: "#0a0a0a",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Every show feels like worship. His voice carries the room into a higher place.",
    author: "Aaliyah R.",
    role: "Fan, NYC",
  },
  {
    quote:
      "Music that actually says something. It's rare and it's needed.",
    author: "Marcus L.",
    role: "Music Critic",
  },
  {
    quote:
      "An artist who lives the message. Pure soul and purpose.",
    author: "Jaden K.",
    role: "Tour Promoter",
  },
];

export const EVENTS = [
  { date: "MAR 14", city: "Brooklyn, NY", venue: "Brooklyn Steel" },
  { date: "MAR 22", city: "Atlanta, GA", venue: "The Tabernacle" },
  { date: "APR 05", city: "London, UK", venue: "Roundhouse" },
  { date: "APR 18", city: "Lagos, NG", venue: "Hard Rock Cafe" },
  { date: "MAY 02", city: "Toronto, CA", venue: "Danforth Music Hall" },
];
